import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CommonStructured from "../common-components/CommonStructured";
import { useDispatch, useSelector } from "react-redux";
import { fetchCentralizedBenefitsData } from "../../redux/reducers/apiSlice";
import { selectAuth } from "../auth/auth.selector";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { EditIcon } from "../../images/icons/website-icons";
import Modal from "react-modal";
import WtfBenefitsForm from "./WtfBenefitsForm";
import FilterContainer from "../common-components/filters/filter-container";
import StatusFilter from "../common-components/filters/status-filter";

const WtfBenefitsLanding = () => {
  const dispatch = useDispatch();

  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { loading, centralizedBenefitsData } = useSelector(
    (state) => state.api
  );

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [initialValue, setInitialValue] = useState(null);

  const initialFilters = {
    // page: ,
    // limit: pageLimit,
    status: "",
  };

  const [filters, setFilters] = useState(initialFilters);

  const getBenefitsData = () => {
    const apiFilters = {
      ...filters,
      status: filters.status?.value || "",
    };

    dispatch(
      fetchCentralizedBenefitsData({
        token: userInfoData?.token,
        filters: apiFilters,
      })
    );
  };

  useEffect(() => {
    getBenefitsData();
  }, [userInfoData, filters]);

  const handleAdd = () => {
    setIsEdit(false);
    setModalOpen(true);
    setInitialValue(null);
  };

  const handleEdit = (row) => {
    setIsEdit(true);
    setModalOpen(true);
    setInitialValue(row);
  };

  function onCloseModalvalues() {
    setModalOpen(false);
  }

  const tbColumns = [
    {
      dataField: "name",
      text: "name",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth100">{row?.name || "-"}</span>;
      },
    },
    {
      dataField: "image",
      text: "image",
      formatter: (cell, row) => {
        return (
          <div
            className=""
            style={{
              textAlign: "center",
            }}
          >
            <img
              src={row?.image || ""}
              alt={row?.name || ""}
              className="image"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "contain",
              }}
            />
          </div>
        );
      },
    },

    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.status || "-"}</span>
        );
      },
    },
    {
      dataField: "actions",
      text: "actions",
      formatter: (cell, row) => {
        return (
          <div className="actionButtonContainer">
            <button
              className="actionBtn icon edit"
              onClick={() => handleEdit(row)}
            >
              <EditIcon />
            </button>

            {/* <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {loading ? <Loader /> : <DeleteIcon />}
          </button> */}
          </div>
        );
      },
    },
  ];

  const handleReset = () => {
    setFilters(initialFilters);
  };

  return (
    <div>
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"WTF Benefits"}
              createBtnTxt={"Add New Facility"}
              onClickCreateBtn={() => handleAdd("add")}
              isReload={() => getBenefitsData()}
            />
          </Col>
        </Row>

        <div>
          <Modal
            isOpen={modalOpen}
            onRequestClose={onCloseModalvalues}
            contentLabel="Career Modal"
            ariaHideApp={false}
          >
            <WtfBenefitsForm
              getBenefitsData={getBenefitsData}
              isEdit={isEdit}
              closeModal={onCloseModalvalues}
              initialValues={initialValue}
              token={userInfoData?.token}
            />
          </Modal>
        </div>

        <div>
          <FilterContainer onReset={handleReset}>
            <StatusFilter
              selectedStatus={filters?.status}
              setSelectedStatus={(option) => {
                setFilters({ ...filters, status: option });
              }}
            />
          </FilterContainer>
        </div>

        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-3">
          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <PaymentLinkTable
              tableData={
                centralizedBenefitsData?.data?.length > 0
                  ? centralizedBenefitsData?.data
                  : []
              }
              tableColumns={tbColumns}
              tablePagination={
                centralizedBenefitsData?.pagination?.length > 0
                  ? centralizedBenefitsData?.pagination
                  : []
              }
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              setPageLimit={setPageLimit}
              pageLimit={pageLimit}
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default WtfBenefitsLanding;
